<template>
  <div class="row">
    <div class="col-md-12">
      <div class="addon-wrapper">
        <div class="addon-info-wrapper">
          <!-- title -->
          <h5 class="addon-title">
            {{ addon.title }}&nbsp;
            <span class="text-danger" v-if="conference.id === 7007 && addon.id === 426">(8:00 am – 12:00 pm EDT) &nbsp;</span>
            <span class="text-danger" v-if="conference.id === 7007 && addon.id === 427">(8:00 am – 12:00 pm EDT) &nbsp;</span>
            <span class="text-danger" v-if="conference.id === 7007 && addon.id === 428">(8:00 am – 12:00 pm EDT) &nbsp;</span>
            <span class="text-danger" v-if="conference.id === 7007 && addon.id === 429">(1:00 pm – 5:00 pm EDT) &nbsp;</span>
            <span class="text-danger" v-if="conference.id === 7007 && addon.id === 430">(10:00 am – 12:00 pm EDT) &nbsp;</span>
            <span class="text-danger" v-if="conference.id === 7007 && addon.id === 431">(1:00 pm – 5:00 pm EDT) &nbsp;</span>
            <span class="text-danger" v-if="conference.id === 7007 && addon.id === 432">(1:00 pm – 4:00 pm EDT) &nbsp;</span>
            <span class="text-danger" v-if="conference.id === 7007 && addon.id === 433">(1:00 pm – 4:00 pm EDT) &nbsp;</span>
            <span class="text-danger" v-if="conference.id === 7007 && addon.id === 434">(8:30 am – 12:30 pm EDT) &nbsp;</span>
            <span class="text-danger" v-if="conference.id === 7007 && addon.id === 435">(1:00 pm – 4:00 pm EDT) &nbsp;</span>
            <span class="text-danger" v-if="conference.id === 7007 && addon.id === 436">(1:00 pm – 5:00 pm EDT) &nbsp;</span>
            <span class="text-danger" v-if="conference.id === 7007 && addon.id === 437">(1:00 pm – 4:00 pm EDT) &nbsp;</span>
            <span class="text-danger" v-if="conference.id === 7007 && addon.id === 438">(1:00 pm – 5:00 pm EDT) &nbsp;</span>

            <span v-if="addon.limit > 0"> - {{ addon.actual_limit }} Spaces Left</span>
          </h5>

          <!-- price -->
          <div class="addon-price default-color">
            {{ currencySymbol }}{{ addon.price }}
          </div>

          <!-- description -->
          <div class="addon-description">
            {{ addon.description }}

            <div v-if="conference.id === 7007 && addon.id === 426">
              <br />
              <h6>Presented By</h6>
              <ul>
                <li>Deborah Rubel, PhD</li>
                <li>Bethany Gravert, MA, LPC</li>
                <li>Priscilla Montero, M.S., PPS</li>
                <li>Briana N. Smith, LPC, CADCI, NCC</li>
              </ul>
            </div>
            <div v-if="conference.id === 7007 && addon.id === 427">
              <br />
              <h6>Presented By</h6>
              <ul>
                <li>Vasti Holstun</li>
                <li>Lynn Bohecker, PhD, LMFT</li>
              </ul>
            </div>
            <div v-if="conference.id === 7007 && addon.id === 428">
              <br />
              <h6>Presented By</h6>
              <ul>
                <li>Ginavra Gibson</li>
                <li>Jung H. Hyun, Ph.D., LP, LMHC, ACS, NCC</li>
              </ul>
            </div>
            <div v-if="conference.id === 7007 && addon.id === 429">
              <br />
              <h6>Presented By</h6>
              <ul>
                <li>LoriAnn Stretch, PhD, LPC (VA), LCMHC-S (NC), NCC, ACS, BC-TMH</li>
                <li>Michael S. Jones, PhD, LPC-S, NCC, BC-TMH</li>
              </ul>
            </div>
            <div v-if="conference.id === 7007 && addon.id === 430">
              <br />
              <h6>Presented By</h6>
              <ul>
                <li>Yoon Suh Moh, Ph.D., LPC, NCC, CRC, BC-TMH, BCN, PhD, LPC, NCC</li>
              </ul>
            </div>
            <div v-if="conference.id === 7007 && addon.id === 431">
              <br />
              <h6>Presented By</h6>
              <ul>
                <li>Patrick R. Mullen, PhD, NCC, NCSC, ACS</li>
                <li>Casey A. Barrio Minton, PhD, NCC</li>
              </ul>
            </div>
            <div v-if="conference.id === 7007 && addon.id === 432">
              <br />
              <h6>Presented By</h6>
              <ul>
                <li>Laura Dawson-Fend, PhD, NCC, LPC, CAADC</li>
                <li>Jung H. Hyun, Ph.D., LP, LMHC, ACS, NCC</li>
                <li>Melissa J Franzen, PhD, LCPC</li>
                <li>Julie Corey, LPC, NCC</li>
              </ul>
            </div>
            <div v-if="conference.id === 7007 && addon.id === 433">
              <br />
              <h6>Presented By</h6>
              <ul>
                <li>Amy Hayes Siler, PhD, NCC</li>
                <li>Sarah Patterson Mills, PhD, LPC</li>
              </ul>
            </div>
            <div v-if="conference.id === 7007 && addon.id === 434">
              <br />
              <h6>Presented By</h6>
              <ul>
                <li>Natoya Hill Haskins, PhD</li>
              </ul>
            </div>
            <div v-if="conference.id === 7007 && addon.id === 435">
              <br />
              <h6>Presented By</h6>
              <ul>
                <li>Kristen Nadermann, PhD, LPC (PA)</li>
              </ul>
            </div>
            <div v-if="conference.id === 7007 && addon.id === 436">
              <br />
              <h6>Presented By</h6>
              <ul>
                <li>Dr. Dione Taylor</li>
              </ul>
            </div>
            <div v-if="conference.id === 7007 && addon.id === 437">
              <br />
              <h6>Presented By</h6>
              <ul>
                <li>K. Lynn Pierce, PhD, CRC, LPC, ACS</li>
                <li>Helen Starkweather, MSOD, LGPC, NCC</li>
              </ul>
            </div>
            <div v-if="conference.id === 7007 && addon.id === 438">
              <br />
              <h6>Presented By</h6>
              <ul>
                <li>Gülşah Kemer, Ph.D., LPC, NCC, ACS</li>
                <li>Anita A. Neuer Colburn, PhD, SIP, LPC (VA), LCMHCS (NC), BC-TMH, ACS, NCC</li>
                <li>Zahide Sunal, Ph.D., NCC, LPC-Associate (TX)</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="addon-quantity-wrapper">
          <!-- quantity -->
          <select
            class="form-control addons"
            v-model="addon.selected"
            @change="onUpdateSelectedAddons"
          >
            <option value="0">0</option>
            <option v-for="quantity in addon.available_limit" :key="`addon-${addon.id}-quantity`" :value="quantity">
              {{ quantity }}
            </option>
          </select>
        </div>
      </div>

      <hr v-if="showLine" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    addonsLength: {
      type: Number,
      default: 0
    },
    addon: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters("basketStore", [
      "slug",
      "conference",
      "tickets",
      "currencySymbol",
      "settings",
      "donation"
    ]),


    showLine() {
      return (this.index + 1) !== this.addonsLength;
    }
  },
  methods: {
    ...mapActions('basketStore', ['updateBasket']),

    onUpdateSelectedAddons() {
      const data = {
        tickets: this.tickets
      };

      this.updateBasket(data)
        .then(() => {})
        .finally(() => {});
    }
  }
}
</script>
